import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { brandName, contact } = siteConfig;
  const location = useLocation();
  const orderNumber = location.state?.orderNumber;

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!orderNumber) {
    return <Navigate to="/cartpage" replace />;
  }

  return (
    <main className="pay-success">
      <section className="pay-success__panel" aria-labelledby="payment-success-heading">
        <div className="pay-success__mark" aria-hidden="true">
          <svg viewBox="0 0 80 80" focusable="false">
            <circle cx="40" cy="40" r="38" />
            <path d="m23 41 11 11 24-26" />
          </svg>
        </div>
        <p className="pay-success__eyebrow">Order received</p>
        <h1 id="payment-success-heading">Thank you.</h1>
        <p className="pay-success__lead">
          Your order is confirmed and our team is getting it ready. A receipt
          and tracking updates will be sent to the contact used at checkout.
        </p>
        <p className="pay-success__order-number">
          Order number <strong>{orderNumber}</strong>
        </p>

        <div className="pay-success__timeline" aria-label="What happens next">
          <article>
            <span>01</span>
            <div>
              <h2>Confirmation</h2>
              <p>Your order details arrive by email shortly.</p>
            </div>
          </article>
          <article>
            <span>02</span>
            <div>
              <h2>Preparation</h2>
              <p>We check and pack every piece before dispatch.</p>
            </div>
          </article>
          <article>
            <span>03</span>
            <div>
              <h2>Tracking</h2>
              <p>We send a tracking link as soon as the parcel leaves.</p>
            </div>
          </article>
        </div>

        <div className="pay-success__actions">
          <Link to="/shop" onClick={toTop} className="pay-success__primary">
            Continue shopping
          </Link>
          <Link to="/shipping" onClick={toTop} className="pay-success__secondary">
            Shipping information
          </Link>
        </div>
      </section>

      <aside className="pay-success__help">
        <p>
          Need help with your {brandName} order? Email
          {` `}<a href={`mailto:${contact.email}`}>{contact.email}</a>.
        </p>
      </aside>
    </main>
  );
};

export default PaySuccess;
